// extracted by mini-css-extract-plugin
export default {"item":"Item_item__WA7Gi","item__box":"Item_item__box__tQruP","item__text":"Item_item__text__ySxyz","item_complete":"Item_item_complete__mcK4D"};